import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-caste-verification',
  templateUrl: './caste-verification.component.html',
  styleUrls: ['./caste-verification.component.css']
})
export class CasteVerificationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/caste-verification/caste-verification.component.ts